import React from 'react';
import '../styles/Message.css';

const Message = ({ message, isOwn }) => {
  // Format timestamp
  const formatTime = (timestamp) => {
    if (!timestamp) return '';
    const date = timestamp.toDate();
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className={`message ${isOwn ? 'sent' : 'received'}`}>
      <div className="message-bubble">
        <div className="message-text">{message.text}</div>
        <div className="message-info">
          <span className="message-time">{formatTime(message.timestamp)}</span>
          {isOwn && (
            <span className="message-status">
              {message.read ? '✓✓' : message.delivered ? '✓' : ''}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(Message);